module.exports = __webpack_public_path__ + "img/img-navbar-logo@3x.17311054.png";